import backend from '@common/backend';

const BASE = '/documents';

export const getDocuments = async (query: any) => backend.get(`${BASE}/`, { params: query });

export const postDocumentsItem = async (data: any) => backend.post(`${BASE}`, data);

export const getDocumentsItem = async (id: number) => backend.get(`${BASE}/${id}`);

export const updateDocumentsItem = async (id: number, data: any) =>
	backend.put(`${BASE}/${id}`, data);

export const deleteDocumentsItem = async (id: number) => backend.delete(`${BASE}/${id}`);
